import styled from 'styled-components';



export const MainWrapper = styled.main`
background-color:#121212;
color:white;

@media(max-width: 800px) {
    width:400px;
  }

`;

export const LeftSide = styled.div`
padding: 50px 0px 0px 80px;
`;

export const SectionTitle = styled.h1`
    font-size:96px;
    margin-bottom:0;
    padding:0;
    background: linear-gradient(90deg, #AC32E4  0%, #4801FF 33%);
    font-family:'Roboto';
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    @media(max-width: 800px) {
    font-size:76px;
    width:400px;
    }

`;

export const SubtitleText = styled.p`
height: 83px;
left: 62px;
top: 994px;

font-family: Roboto;
font-style: normal;
font-weight: normal;
font-size: 24px;
line-height: 28px;

color: #FFFFFF;

@media(max-width: 800px) {
  display:none;
  
  }
`

export const GridCards = styled.div`
display:flex;
flex-direction:row;
margin: 40px 80px;
flex-wrap:wrap;
`